import { ApiProperty } from '@nestjs/swagger';
import { Types } from 'mongoose';

import { ToObjectId } from '../decorators';
import { IsObjectId } from '../validators';

export class UpdateInputModel {
  @ApiProperty({ type: String, format: 'bson' })
  @IsObjectId()
  @ToObjectId()
  public id!: Types.ObjectId;
}
